import { sipCtiSubscribeStates } from './sipctisubscribestates.js';

import { assign, sendParent, send } from 'xstate';

// top 
export const sipRegisterStates = {
    initial: 'inactive',
    states: {
        inactive: {
            on: {
                DO_AUTOREGISTER: {
                    target: 'tryingRegister',
                    actions: assign((context, event) => ({
                        registerHeaders: ({ "IPFX-CTI-Opaque-ID": context.opaqueId })
                    })),
                    cond: context => context.instanceId == 0 && context.autoregister
                },
                DO_REGISTER: {
                    target: 'tryingRegister',
                    actions: assign((context, event) => ({
                        registerSipserver: context.instanceId == 0 ? event.sipserver : context.registerSipserver,
                        registerUsername: context.instanceId == 0 ? event.sipserver.replace("sip:", "sip:" + event.username + "@") : context.registerUsername,
                        registerSecret: context.instanceId == 0 ? event.secret : context.registerSecret,
                        registerIsHa1Secret: context.instanceId == 0 ? event.is_ha1_secret : context.registerIsHa1Secret,
                        registerDisplayname: context.instanceId == 0 ? event.displayName : context.registerDisplayname,
                        registerHeaders: ({ "IPFX-CTI-Opaque-ID": context.opaqueId }),
                        smTarget: event.smTarget
                    }))
                }
            }
        },
        unregistered: {
            entry: sendParent(context => ({ type: 'PLUGIN_UNREGISTERED', instanceId: context.instanceId })),
            on: {
                DO_REGISTER: 'tryingRegister',
                DO_UNREGISTER: {},
            }
        },
        tryingRegister: {
            entry: registerAction,
            on: {
                DO_UNREGISTER: 'unregistered',
                REGISTERING: { actions: sendParent(context => ({ type: 'PLUGIN_RETRYING_REGISTER', instanceId: context.instanceId })) },
                REGISTRATION_FAILED: { target: 'retryingRegister', actions: sendParent((context, event) => ({ type: 'PLUGIN_REGISTRATION_FAILED', instanceId: context.instanceId, error: event.result["code"] + " " + event.result["reason"] })) },
                REGISTERED: { target: 'registered', actions: assign((context, event) => ({ masterId: event.result["master_id"], registerDisplayname: event.result["displayname"] })) },
            }
        },
        tryingUnregister: {
            entry: [unregisterAction, sendParent(context => ({ type: 'PLUGIN_TRYING_UNREGISTER', instanceId: context.instanceId }))],
            on: {
                UNREGISTERED: 'unregistered',
            },
        },
        retryingRegister: {
            entry: sendParent(context => ({ type: 'PLUGIN_RETRYING_REGISTER', instanceId: context.instanceId })),
            after: { 30000: 'tryingRegister' },
            on: {
                DO_UNREGISTER: 'unregistered'
            },
        },
        registered: {
            entry: sendParent((context, event) => ({ type: 'PLUGIN_REGISTERED', instanceId: context.instanceId, masterId: context.masterId, registerUsername: context.registerUsername, displayName: context.registerDisplayname })),
            on: {
                REGISTERING: {},
                REGISTERED: {},
                REGISTRATION_FAILED: { target: 'retryingRegister', actions: sendParent((context, event) => ({ type: 'PLUGIN_REGISTRATION_FAILED', instanceId: context.instanceId, error: event.error })) },
                UNREGISTERED: 'unregistered',
                DO_UNREGISTER: 'tryingUnregister',
            },
            ...sipCtiSubscribeStates
        }
    } // states
}

function registerAction(context, event) {
    let register = { request: "register" };
    register["username"] = context.registerUsername;
    if (context.instanceId == 0) {
        register["proxy"] = context.registerSipserver;
        register["force_tcp"] = context.registerUsername.startsWith('sip:guest-');
        if (context.registerIsHa1Secret) {
            register["ha1_secret"] = context.registerSecret;
        }
        else {
            register["secret"] = context.registerSecret;
        }
        if (context.registerDisplayname) {
            register["display_name"] = context.registerDisplayname;
        }
        register["incoming_header_prefixes"] = ["Push-call-id", "Remote-Party-Id"];
        if (context.pushToken) {
            register["headers"] = Object.assign({}, context.registerHeaders,
                { "IPFX-Push-Token": '"' + context.pushToken + '"' + (context.alertPushToken ? (';alert="' + context.alertPushToken + '"') : '') + (context.pushPlatformName ? (';platform=' + context.pushPlatformName) : '') });
        } else {
            register["headers"] = context.registerHeaders;
        }
        if (context.monitorTarget) {
            register["contact_params"] = ({"ipfx-sm-target": context.monitorTarget });
        }
    } else {
        register["type"] = "helper";
        register["master_id"] = context.masterId;
    }
    context.pluginHandle.send({ message: register });
}

function unregisterAction(context, event) {
    context.pluginHandle.send({ message: { request: "unregister" } });
}


